import styled from "styled-components";
import { Col } from "antd";
import ScreenHelper from "components/Styled/ScreenHelper";
import { ColSize } from "antd/lib/col";


declare type ColSpanType = ColSize;
export const RightColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 7,
        offset: 0,
    },
    lg: {
        span: 7,
        offset: 0,
    },
    md: {
        span: 7,
        offset: 0,
    },
    sm: {
        span: 10,
        offset: 0
    },
    xs: {
        span: 10,
        offset: 0
    }
};

export const LeftColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 5,
        offset: 0,
    },
    lg: {
        span: 5,
        offset: 0,
    },
    md: {
        span: 5,
        offset: 0,
    },
    sm: {
        span: 10,
        offset: 1
    },
    xs: {
        span: 10,
        offset: 1
    },
};

export const TableCol = styled(Col)`

margin-bottom: 10px;

${ScreenHelper.down('sm', 'xs')`
  margin-bottom: 15px;
  `}
`;

export const HeaderCol = styled(Col)`

border-bottom: solid 1px lightgrey;
`;

